import _ from 'underscore';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const NormalizedEmitter = assign({}, EventEmitter.prototype);

export default NormalizedEmitter;


// WEBPACK FOOTER //
// ./src/utilities/NormalizedEmitter/index.js